if (typeof CartForm !== "function") {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();
      this.updateGiftWrapVisibility();
      this.syncGiftWrapCheckboxes();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector("form");

      this.querySelectorAll("[data-js-cart-item]").forEach((item) => {
        const remove = item.querySelector(".remove");
        if (remove) {
          remove.dataset.href = remove.getAttribute("href");
          remove.setAttribute("href", "");
          remove.addEventListener("click", (e) => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector(".qty");
        if (qty) {
          qty.addEventListener(
            "input",
            debounce((e) => {
              e.preventDefault();
              e.target.select();
              this.updateCartQty(item, parseInt(qty.value));
            }, 500)
          );
          qty.addEventListener("click", (e) => {
            e.target.select();
          });
        }
      });
    }

    // カート内のアイテムをチェックしてギフトラップのチェックボックス状態を同期
    syncGiftWrapCheckboxes() {
      const cartItems = Array.from(
        document.querySelectorAll("[data-js-cart-item]")
      );
      const giftWrapCheckboxes = document.querySelectorAll(
        ".gift-wrap__checkbox"
      );

      giftWrapCheckboxes.forEach((checkbox) => {
        const variantId = checkbox.getAttribute("data-variant-id");
        // カート内にこのvariantIdを持つアイテムが存在するかチェック
        const isInCart = cartItems.some(
          (item) => item.getAttribute("id") === "item-" + variantId
        );
        checkbox.checked = isInCart;
      });
    }

    calculateTotalQuantity() {
      let totalQty = 0;
      this.querySelectorAll("[data-js-cart-item]").forEach((item) => {
        const qty = item.querySelector(".qty");
        if (qty) {
          totalQty += parseInt(qty.value || 0);
        }
      });
      return totalQty;
    }

    updateGiftWrapVisibility() {
      const totalQty = this.calculateTotalQuantity();
      const giftWrap2Container = document
        .querySelector('input[name="gift_wrap_2"]')
        .closest("label");

      if (totalQty >= 2) {
        giftWrap2Container.style.display = "block";
      } else {
        // 2本未満の場合、チェックボックスをオフにして非表示
        const giftWrap2Checkbox = document.querySelector(
          'input[name="gift_wrap_2"]'
        );
        if (giftWrap2Checkbox.checked) {
          giftWrap2Checkbox.checked = false;
          // チェックが外れた時にカートから削除
          const variantId = giftWrap2Checkbox.getAttribute("data-variant-id");
          this.removeGiftWrap(variantId);
        }
        giftWrap2Container.style.display = "none";
      }
    }

    removeGiftWrap(variantId) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          window.refreshCart();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }

    updateCartQty(item, newQty) {
      let alert = null;

      this.form.classList.add("processing");
      if (this.querySelector(".alert")) {
        this.querySelector(".alert").remove();
      }

      const body = JSON.stringify({
        line: parseInt(item.dataset.line),
        quantity: newQty,
      });

      fetch(KROWN.settings.routes.cart_change_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/javascript",
        },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status == 422) {
            alert = document.createElement("span");
            alert.classList.add("alert", "alert--error");
            if (typeof response.description === "string") {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
          }
          return fetch("?section_id=helper-cart");
        })
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(
            text,
            "text/html"
          );
          const cartFormInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
          const cartSubtotalInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

          const cartItems = document.getElementById("AjaxCartForm");
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          document
            .querySelectorAll("[data-header-cart-count]")
            .forEach((elm) => {
              elm.textContent =
                cartItems.querySelector("[data-cart-count]").textContent;
            });
          document
            .querySelectorAll("[data-header-cart-total")
            .forEach((elm) => {
              elm.textContent =
                cartItems.querySelector("[data-cart-total]").textContent;
            });

          if (alert !== null) {
            this.form.prepend(alert);
          }

          document.getElementById("AjaxCartSubtotal").innerHTML =
            cartSubtotalInnerHTML;

          const event = new Event("cart-updated");
          this.dispatchEvent(event);

          // カート更新後にギフトラップの表示状態を更新
          this.updateGiftWrapVisibility();
          // チェックボックスの状態を同期
          this.syncGiftWrapCheckboxes();
        })
        .catch((e) => {
          console.log(e);
          let alert = document.createElement("span");
          alert.classList.add("alert", "alert--error");
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => {
          this.form.classList.remove("processing");
        });
    }
  }

  if (typeof customElements.get("cart-form") == "undefined") {
    customElements.define("cart-form", CartForm);
  }
}

if (typeof CartProductQuantity !== "function") {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector(".qty-minus").addEventListener(
        "click",
        this.changeCartInput.bind(this)
      );
      this.querySelector(".qty-plus").addEventListener(
        "click",
        this.changeCartInput.bind(this)
      );
    }
    changeCartInput() {
      setTimeout(() => {
        document
          .getElementById("AjaxCartForm")
          .updateCartQty(
            this.closest("[data-js-cart-item]"),
            parseInt(this.querySelector(".qty").value)
          );
      }, 50);
    }
  }

  if (typeof customElements.get("cart-product-quantity") == "undefined") {
    customElements.define("cart-product-quantity", CartProductQuantity);
  }
}

if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch("?section_id=helper-cart")
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(
          text,
          "text/html"
        );
        const cartFormInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
        const cartSubtotalInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

        const cartItems = document.getElementById("AjaxCartForm");
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
          elm.textContent =
            cartItems.querySelector("[data-cart-count]").textContent;
        });
        document.querySelectorAll("[data-header-cart-total").forEach((elm) => {
          elm.textContent =
            cartItems.querySelector("[data-cart-total]").textContent;
        });

        document.getElementById("AjaxCartSubtotal").innerHTML =
          cartSubtotalInnerHTML;
        if (document.querySelector("[data-js-site-cart-sidebar]")) {
          document.querySelector("[data-js-site-cart-sidebar]").show();
        }

        if (document.querySelector("cart-recommendations")) {
          document.querySelector("cart-recommendations").innerHTML = "";
          document
            .querySelector("cart-recommendations")
            .generateRecommendations();
        }

        // カート更新後にギフトラップの表示状態を更新
        const cartForm = document.getElementById("AjaxCartForm");
        cartForm.updateGiftWrapVisibility();
        // チェックボックスの状態を同期
        cartForm.syncGiftWrapCheckboxes();
      });
  };
}
